import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'


import App from './App.vue'

import Vuesax from 'vuesax3'
import 'material-icons/iconfont/material-icons.css';

import 'vuesax3/dist/vuesax.css'
import './styles/base.css'
import router from './router'

import { VueQueryPlugin } from '@tanstack/vue-query'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

pinia.use(createPersistedState({
    storage: localStorage,
}))

app.use(router)
app.use(Vuesax)
app.use(VueQueryPlugin)
app.use(pinia)
app.use(head)

app.mount('#app')
